module.exports = __webpack_public_path__ + "img/matics.e18bda97.png";